import { Link } from 'react-router-dom';

import { Container } from '../ui/Container';

const navItems = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/board', label: 'The Board' },
  { to: '/documents', label: 'Documents' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/contact', label: 'Contact' },
];

export function Footer(): JSX.Element {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-24 bg-brand-charcoal text-brand-white">
      <Container as="div" className="grid gap-12 py-16 md:grid-cols-12 md:py-20">
        <div className="md:col-span-5">
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo.webp" alt="" className="h-12 w-12 shrink-0" />
            <span className="flex flex-col leading-tight">
              <span className="text-lg font-bold tracking-heading-tight">Sunset Harbor</span>
              <span className="text-xs uppercase tracking-[0.18em] text-brand-body-light">
                Condominiums
              </span>
            </span>
          </Link>
          <address className="mt-6 not-italic text-sm leading-relaxed text-brand-body-light">
            3873 South Banana River Boulevard
            <br />
            Cocoa Beach, FL 32931
          </address>
          <p className="mt-4 text-sm text-brand-body-light">
            On the Banana River. Two blocks to the Atlantic.
          </p>
        </div>

        <div className="md:col-span-7">
          <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-brand-body-light">
            Explore
          </h2>
          <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2 text-sm sm:grid-cols-3">
            {navItems.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-brand-white transition-colors hover:text-brand-yellow"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </Container>

      <div className="border-t border-white/10">
        <Container
          as="div"
          className="flex flex-col items-start gap-2 py-6 text-xs text-brand-body-light md:flex-row md:items-center md:justify-between"
        >
          <p>
            &copy; {year} Sunset Harbor Owners&rsquo; Association. All rights reserved. Site by{' '}
            <a
              href="https://stephenscode.dev"
              className="text-brand-body-light hover:text-brand-body-light"
              style={{ textDecoration: 'none' }}
            >
              StephensCode
            </a>
            .
          </p>
          <p>Florida Statute 718 compliant. Records request response time: 10 working days.</p>
        </Container>
      </div>
    </footer>
  );
}
